import { styled } from "@mui/material/styles";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { theme } from "styles/themes";
import { filterStyledProps } from "lib/helpers/filterStyledProps";
import { mq } from "styles";

const formLabelProps = {
  fontSize: "12px",
  fontWeight: "600",
  color: theme.colors["nepal-blue"],
  lineHeight: "10px",
};

export const DisclaimerText = styled(Typography)(() => ({
  fontSize: "16px",
  fontStyle: "italic",
  fontWeight: 500,
  lineHeight: "19.2px",
  textAlign: "left",
  color: theme.colors["congress-blue"],
}));

export const StyledSectionLabel = styled("div", { shouldForwardProp: filterStyledProps(["sub"]) })(
  ({ sub }: { sub?: boolean }) =>
    () => ({
      fontFamily: "Poppins",
      fontWeight: "400",
      fontSize: sub ? "18px" : "20px",
      lineHeight: "30px",
      color: theme.colors["blue-ribbon"],
    }),
);

export const FormFieldLabel = styled("div")(() => ({
  ...formLabelProps,
  textTransform: "uppercase",
  marginBottom: "8px",
}));

export const ExistingSystemLabel = styled("div")(() => ({
  ...formLabelProps,
  lineHeight: "16px",
  textTransform: "uppercase",
  marginTop: "4px",
}));

export const StyledDivider = styled(Divider)(() => ({
  background: theme.colors["botticelli-blue"],
  marginTop: "28px",
  marginBottom: "30px",
}));

export const NoteUrgent = styled("div")(() => ({
  marginTop: "5px",
  fontWeight: 600,
  lineHeight: "17px",
  color: theme.colors["persian-red"],
}));

export const Note = styled("div")(() => ({
  marginTop: "5px",
  marginBottom: "8px",
  fontWeight: 600,
  lineHeight: "17px",
  color: theme.colors["nepal-blue"],
}));

export const DarkBlueNote = styled("div")(() => ({
  fontSize: "12px",
  fontWeight: 600,
  lineHeight: "17px",
  color: theme.colors["dark-blue"],
}));

export const DarkBlueLabel = styled("div")(() => ({
  fontSize: "16px",
  fontWeight: 600,
  color: theme.colors["dark-blue"],
}));

export const ImageUploadNote = styled("div", { shouldForwardProp: filterStyledProps(["isUploaderOpen"]) })(
  ({ isUploaderOpen }: { isUploaderOpen?: boolean }) => ({
    display: "flex",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "19px",
    color: theme.colors["dark-blue"],
    marginBottom: isUploaderOpen ? "12px" : "0px",
    flexWrap: "wrap",
    rowGap: "14px",
  }),
);

export const ImageUploadContainer = styled("div")(() => ({
  background: theme.colors["botticelli-blue-35"],
  width: "100%",
  borderRadius: "8px",
  padding: "16px",
  marginLeft: "16px",
}));

export const ImageUploadClickable = styled("div")(() => ({
  display: "flex",
  marginLeft: "5px",
  color: theme.colors["blue-ribbon"],
  cursor: "pointer",
}));

export const ClickableCaret = styled("div", { shouldForwardProp: filterStyledProps(["isUploaderOpen"]) })(
  ({ isUploaderOpen }: { isUploaderOpen?: boolean }) => ({
    paddingTop: isUploaderOpen ? "1px" : "3px",
    marginLeft: isUploaderOpen ? "4px" : "0px",
  }),
);

export const CustomFieldsContainer = styled("div")(() => ({
  [mq.tabletUp]: {
    marginTop: "30px",
  },
}));

export const Red = styled("span")(() => ({
  color: theme.colors.danger,
}));

export const StyledOrRow = styled(Grid)(() => ({
  fontWeight: 700,
  fontSize: "16px",
  textTransform: "uppercase",
  color: theme.colors["nepal-blue"],
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  [mq.tabletUp]: {
    marginTop: "12px",
  },
}));

export const ItalicNote = styled("div")(() => ({
  fontWeight: 500,
  color: theme.colors["nepal-blue"],
  fontStyle: "italic",
}));

export const EnergyUsageInputContainer = styled(Grid)(() => ({
  [mq.tabletDown]: {
    background: theme.colors.white,
    marginTop: "0px",
    width: "100%",
    marginLeft: "0px",
    padding: "8px 28px 24px 12px",
    borderRadius: "10px",
  },
}));
